module.exports = __webpack_public_path__ + "static/media/19ESCAP13.07a4452f.jpg";